"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
var _customerCoupon = require("@/api/activity/customerCoupon");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'customerCouponRule',
  emits: ['couponRuleAdd'],
  props: {
    refresh: {
      type: Number,
      default: 0
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler() {
        this.getRuleList();
      }
    }
  },
  data: function data() {
    return {
      // 搜索表单
      searchForm: {
        ruleName: '',
        status: '',
        page: 1,
        limit: 10,
        total: 0,
        startTime: '',
        endTime: ''
      },
      // 日期范围
      dateRange: [],
      // 规则列表
      ruleList: [],
      // 新增/编辑对话框
      dialogVisible: false,
      dialogTitle: '',
      // 详情对话框
      detailVisible: false,
      // 表单数据
      form: {
        id: '',
        tenantCode: '',
        ruleName: '',
        couponId: '',
        defaultLimit: 120.00,
        effectiveLogic: 1,
        status: 0
      },
      // 表单验证规则
      rules: {
        ruleName: [{
          required: true,
          message: '请输入规则名称',
          trigger: 'blur'
        }],
        couponId: [{
          required: true,
          message: '请输入券ID',
          trigger: 'blur'
        }],
        defaultLimit: [{
          required: true,
          message: '请输入默认额度',
          trigger: 'blur'
        }]
      },
      loading: false
    };
  },
  mounted: function mounted() {
    this.getRuleList();
  },
  methods: {
    // 获取规则列表
    getRuleList: function getRuleList() {
      var _this = this;
      this.loading = true;
      (0, _customerCoupon.getCouponRule)(this.searchForm).then(function (res) {
        if (res.code === 200) {
          _this.ruleList = res.records || [];
          _this.searchForm.total = res.total || 0;
        } else {
          _this.$message.error(res.msg || '查询规则列表失败');
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getRuleList();
    },
    // 重置
    handleReset: function handleReset() {
      this.searchForm = {
        ruleName: '',
        status: '',
        page: 1,
        limit: 10,
        total: 0,
        startTime: '',
        endTime: ''
      };
      this.dateRange = [];
      this.getRuleList();
    },
    // 处理日期范围变化
    handleDateChange: function handleDateChange(val) {
      if (val && val.length === 2) {
        this.searchForm.startTime = val[0];
        this.searchForm.endTime = val[1];
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getRuleList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getRuleList();
    },
    // 新增
    handleAdd: function handleAdd() {
      this.$emit('couponRuleAdd');
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.$emit('handleEdit', row);
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm('确定要删除这条规则吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customerCoupon.delCouponRule)({
          id: row.id
        }).then(function (res) {
          if (res.code === 200) {
            _this2.$message.success('删除成功');
            _this2.getRuleList();
          } else {
            _this2.$message.error(res.msg || '删除失败');
          }
        }).catch(function (err) {
          _this2.$message.error('网络错误，请稍后重试');
        });
      });
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          // 新增或更新
          if (_this3.form.id) {
            (0, _customerCoupon.updCouponRule)(_this3.form).then(function (res) {
              if (res.code === 200) {
                _this3.$message.success('更新成功');
                _this3.dialogVisible = false;
                _this3.getRuleList();
              } else {
                _this3.$message.error(res.msg || '更新失败');
              }
            }).catch(function (err) {
              _this3.$message.error('网络错误，请稍后重试');
            }).finally(function () {
              _this3.loading = false;
            });
          } else {
            (0, _customerCoupon.saveCouponRule)(_this3.form).then(function (res) {
              if (res.code === 200) {
                _this3.$message.success('新增成功');
                _this3.dialogVisible = false;
                _this3.getRuleList();
              } else {
                _this3.$message.error(res.msg || '新增失败');
              }
            }).catch(function (err) {
              _this3.$message.error('网络错误，请稍后重试');
            }).finally(function () {
              _this3.loading = false;
            });
          }
        }
      });
    },
    // 获取状态类型
    getStatusType: function getStatusType(status) {
      switch (status) {
        case 0:
          return '';
        case 1:
          return 'success';
        case 2:
          return 'danger';
        default:
          return '';
      }
    },
    // 获取状态文本
    getStatusText: function getStatusText(status) {
      switch (status) {
        case 0:
          return '未启用';
        case 1:
          return '启用';
        case 2:
          return '已删除';
        default:
          return '';
      }
    },
    // 格式化日期
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};